import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { ViewEncapsulation } from '@angular/core';

import { Alert } from 'src/app/alert/alert';
import { AlertType } from 'src/app/alert/alert-type';
import { AlertService } from 'src/app/alert/alert.service';
import { Filter, FilterMethod, FilterProperty } from '@mango/core';
import { takeUntil } from 'rxjs/operators';

import { AuthenticationService } from '@mango/authentication';
import { Subject } from 'rxjs/internal/Subject';

@Component({
    selector: 'mtp-alert-popup',
    templateUrl: './alert-popup.component.html',
    styleUrls: ['./alert-popup.component.css']
})
export class AlertsPopupComponent {

    protected onDestroy$ = new Subject<void>();
    
    alerts: Alert[];
    alertType = AlertType;
    loading: boolean;
    amountOfNotifications: number = 0;
    currentUserId: number;

    constructor(private service: AlertService, private authService: AuthenticationService) { }

    ngOnInit() {
        this.loading = true;
        this.currentUserId = +this.authService.currentUser.id;

        this.loadAlerts();

        this.service.hubSubject.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            this.loadAlerts();
        });

        this.loading = false;

    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    loadAlerts() {
        this.loading = true;
        this.service.get({
            properties: ['title', 'date', 'message'],
            orderBy: [-2],
            filter: [new FilterProperty<Alert>('valid', FilterMethod.Equal, true)]

        }).toPromise().then(x => {

            this.alerts = x.data;
            this.amountOfNotifications = this.alerts.length;

            this.loading = false;
        });
    }

    getColor(alert: Alert): string {
        switch (alert.type) {
            case AlertType.Notification:
                return '#23a5df';
            default:
                return '#23a5df';
        }
    }

    getIcon(alert: Alert): string {
        switch (alert.type) {
            case AlertType.Notification:
                return 'info';
            default:
                return 'info_outline';
        }
    }
}
